import { Spinner } from "@public/ui-toolkit";
import React, { useState } from "react";
import CanCan from "../CanCan";
import DocumentModal from "../DocumentModal";

const statusEnum = [
  {
    name: "Submitted",
    key: 0,
  },
  {
    name: "Approved",
    key: 1,
  },
  {
    name: "Rejected",
    key: 2,
  },
  {
    name: "Timeout",
    key: 3,
  },
];

const DocumentAgreement = ({
  allDocuments,
  onUploadDocuments,
  fundInvestorId,
  onUpdateDocumentStatus,
  index,
  loading,
  updatedDocType,
  roles,
  Permissions,
}) => {
  const [rejectedComment, setRejectedComment] = useState();
  const [statusId, setStatusId] = useState();
  const [docModalVisible, setDocModalVisible] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  const uploadDocument = (type, input) => {
    let file = input.files[0];
    const formData = new FormData();

    formData.append(`Type`, type);
    formData.append(`FundInvestorId`, fundInvestorId);
    formData.append(`Document`, file);

    onUploadDocuments(formData, type);
  };
  const ShowFile = (url) => {
    setFileUrl(url);
    setDocModalVisible(true);
  }
  const updateStatus = (documentId) => {
    onUpdateDocumentStatus({
      id: documentId,
      status: statusId,
      rejectedComment: rejectedComment,
    });
  };

  const documentStatus = (status) => {
    let activeStatus = statusEnum.find(({ key }) => status === key);
    return activeStatus?.name;
  };
  return (
    <div className="row g-5">
      {allDocuments?.map((documents, index) => {
        return (
          <div className="col col-lg-3 col-sm-1">
            <div className="card doc-card" style={{ borderRadius: "10px" }}>
              <div
                className="card-header document-header p-3"
                style={{ borderRadius: "10px 10px 0px 0px" }}
              >
                <h5 className="d-inline" style={{ color: "#fff" }}>
                  {documents?.value}
                </h5>
                <div
                  className="badge badge-default badge-outlined "
                  style={{ float: "right" }}
                >
                  {documents?.document?.status === 0 && (
                    <i className="fa fa-circle" style={{ color: "#f5c71a" }}></i>
                  )}
                  {documents?.document?.status === 1 && (
                    <i className="fa fa-circle" style={{ color: "#8eb77d" }}></i>
                  )}
                  {documents?.document?.status === 2 && (
                    <i className="fa fa-circle" style={{ color: "#ff7171" }}></i>
                  )}
                  {documents?.document?.status === 3 && (
                    <i className="fa fa-circle" style={{ color: "#ff7171" }}></i>
                  )}{" "}
                  {documentStatus(documents?.document?.status) ? (
                    documentStatus(documents?.document?.status)
                  ) : (
                    <>
                      <i className="fa fa-circle"></i> Not submitted
                    </>
                  )}
                </div>
              </div>

              {/* <CanCan permissionName={Permissions?.CONTRACT_DOC_UPLOAD?.name}> */}
              <div className="card-body doc-card-body text-center p-5">
                {loading && updatedDocType === documents.key ? (
                  <Spinner />
                ) : (
                  <>
                    {documents?.document?.url ? (
                      <div className="d-flex flex-column">
                        <i
                          className="fa fa-file-pdf-o fa-3x mb-3"
                          onClick={() => ShowFile(documents?.document?.url)}
                          title="View Document"
                        ></i>
                        <span> {documents?.document?.name}</span>
                      </div>
                    ) : (
                      <div className="image-upload">
                        <label
                          for={`file-input${index}`}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa fa-upload fa-3x"></i>
                        </label>
                        <input
                          id={`file-input${index}`}
                          type="file"
                          accept=".xlsx, .xls, .csv, .pdf"
                          onChange={(e) => uploadDocument(documents?.key, e.target)}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* </CanCan> */}

              <div className="card-footer doc-card-footer p3 d-flex flex-column justify-content-center">
                {documents?.document?.status === 0 &&
                  documents?.document?.editable === true ? (
                  <CanCan
                    permissionName={Permissions?.CONTRACT_DOC_APPROVE?.NAME}
                    roles={roles}
                  >
                    <form>
                      <div className="row mt-2">
                        <div className="col">
                          <input
                            type="radio"
                            className="btn-check "
                            name={`options-outlined`}
                            id={`success-outlined${index}`}
                            autocomplete="off"
                            // checked
                            onChange={() => {
                              setStatusId(1);
                              document.getElementById("p2").style.color = "green";
                            }}
                          />
                          <label
                            className="btn btn-outline-success w-100"
                            for={`success-outlined${index}`}
                          >
                            <i className="fa fa-thumbs-up"></i> Accept
                          </label>
                        </div>
                        <div className="col">
                          <input
                            type="radio"
                            className="btn-check"
                            name={`options-outlined`}
                            id={`danger-outlined${index}`}
                            autocomplete="off"
                            onChange={() => {
                              setStatusId(2);
                              document.getElementById("p2").style.color = "red";
                            }}
                          />
                          <label
                            className="btn btn-outline-danger w-100"
                            for={`danger-outlined${index}`}
                          >
                            <i className="fa fa-thumbs-down"></i> Reject
                          </label>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col" style={{ position: "relative" }}>
                          <textarea
                            rows="2"
                            type="text"
                            className="form-control mb-2"
                            placeholder="Rejected Comment"
                            onChange={(e) => {
                              setRejectedComment(e.target.value);
                            }}
                          />
                          <i
                            className="fa fa-paper-plane"
                            id="p2"
                            style={{
                              position: "absolute",
                              top: 20,
                              right: 20,
                              fontSize: "20px",
                            }}
                            onClick={() => updateStatus(documents?.document?.id)}
                          />
                        </div>
                      </div>
                    </form>
                  </CanCan>
                ) : (
                  <>
                    {documents?.document?.status === 1 ? (
                      <h6 className="text-center">
                        {documents?.value} document has been approved!
                      </h6>
                    ) : (
                      <div className="image-upload upload-doc">
                        <label
                          for={`file-input${index}`}
                          style={{ cursor: "pointer" }}
                          className="reupload-btn"
                        >
                          <i className="fa fa-upload fa text-center"></i>
                          {documents?.document ? (
                            <span> Reupload</span>
                          ) : (
                            <span> Upload</span>
                          )}
                        </label>
                        <input
                          className="d-none"
                          id={`file-input${index}`}
                          type="file"
                          accept=".xlsx, .xls, .csv, .pdf"
                          onChange={(e) => uploadDocument(documents?.key, e.target)}
                        />
                      </div>
                    )}
                    {documents?.document?.status === 2 ||
                      documents?.document?.status === 3 ? (
                      <div className="rejected-comment">
                        <h6 className="text-left" style={{ fontSize: "13px" }}>
                          Rejected Comment: <br />
                        </h6>
                        <p
                          className="text-left rejected-description"
                          style={{ fontSize: "12px", fontWeight: 400 }}
                        >
                          {documents?.document?.rejectedComment}
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
            </div>

            {docModalVisible && (
              <DocumentModal src={fileUrl} open={docModalVisible} onClose={() => setDocModalVisible(false)} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DocumentAgreement;
